var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7927 0.947106C11.988 0.751844 12.3046 0.751844 12.4998 0.947105L15.3283 3.77552C15.422 3.86929 15.4747 3.99647 15.4747 4.12908C15.4747 4.26169 15.422 4.38886 15.3283 4.48263L4.95737 14.8535C4.8636 14.9473 4.73642 15 4.60381 15L1.77547 14.9999C1.49933 14.9999 1.27549 14.7761 1.27548 14.4999L1.27539 11.6716C1.27539 11.5389 1.32807 11.4118 1.42184 11.318L11.7927 0.947106ZM12.1463 2.00777L2.2754 11.8786L2.27546 13.9999L4.39672 14L14.2676 4.12908L12.1463 2.00777Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96383 3.77554C9.15909 3.58027 9.47567 3.58027 9.67094 3.77554L12.4994 6.60397C12.6946 6.79923 12.6946 7.11581 12.4994 7.31108C12.3041 7.50634 11.9875 7.50634 11.7923 7.31108L8.96383 4.48264C8.76857 4.28738 8.76857 3.9708 8.96383 3.77554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/editWhite.30a1f92e3dda695594e5df5bb44de962.svg";
export { ForwardRef as ReactComponent };